import { type ReactNode } from "react";

interface BrandedStateShellProps {
  routeLabel: string;
  children: ReactNode;
  mainLabel?: string;
  variant?: "app" | "auth";
  footerMeta?: string | string[];
}

export function BrandedStateShell({
  routeLabel,
  children,
  mainLabel,
  variant = "app",
  footerMeta,
}: BrandedStateShellProps) {
  const metadata = normalizeMeta(footerMeta);

  return (
    <div
      className={`flex min-h-screen flex-col bg-[rgb(var(--starling-bg))] text-[rgb(var(--starling-text-primary))]${variant === "auth" ? " starling-auth-theme" : ""}`}
    >
      <header
        className="flex min-h-16 items-center justify-between gap-4 border-b border-[rgb(var(--starling-border))] bg-[rgb(var(--starling-panel)/0.92)] px-4 md:px-6"
        role="banner"
      >
        <div className="flex min-w-0 items-center gap-3">
          <img
            src="/images/brand/logo-v2.svg"
            alt=""
            aria-hidden="true"
            className="h-auto w-8 shrink-0"
          />
          <div className="min-w-0">
            <div className="text-sm font-semibold leading-5">DRiskify</div>
            <div className="truncate text-xs text-[rgb(var(--starling-text-tertiary))]">
              Starling
            </div>
          </div>
        </div>
        <div className="min-w-0 rounded-md border border-[rgb(var(--starling-border))] bg-[rgb(var(--starling-elevated))] px-3 py-1.5 text-right">
          <div className="truncate text-xs font-medium text-[rgb(var(--starling-text-secondary))]">
            {routeLabel}
          </div>
        </div>
      </header>
      <main
        className="grid flex-1 place-items-center px-4 py-8 md:px-6"
        aria-label={mainLabel ?? routeLabel}
      >
        {children}
      </main>
      <footer
        className="flex min-h-12 flex-wrap items-center justify-between gap-2 border-t border-[rgb(var(--starling-border))] bg-[rgb(var(--starling-shell))] px-4 py-3 text-xs text-[rgb(var(--starling-text-tertiary))] md:px-6"
        role="contentinfo"
      >
        <span>Starling by DRiskify</span>
        <span className="flex flex-wrap justify-end gap-x-3 gap-y-1">
          {metadata.map((item) => (
            <span key={item}>{item}</span>
          ))}
        </span>
      </footer>
    </div>
  );
}

function normalizeMeta(meta?: string | string[]) {
  if (Array.isArray(meta)) return meta.filter(Boolean);
  if (meta) return [meta];
  return [`mode ${import.meta.env.MODE}`];
}
